<template>
    <ClientOnly>
        <TranslateButton v-if="isTranslationActivated && experiencesSectionState.length > 0" section="experience" />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
</template>
<script setup lang="ts">
    import {onMounted, onUnmounted} from 'vue';
    import {storeToRefs} from 'pinia';
    import TranslateButton from '~/components/main/TranslateButton.vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {eventBus} from '~/config/events';
    import {TranslationDirection, useTranslationStore} from '~/store/translation/translationStore';
    import {useExperienceSectionState} from '../../composable/useExperienceSectionState';

    const translationSection = 'experiences';
    const translationTitleField = 'title';
    const translationDescriptionField = 'description';

    // State
    const experiencesSectionState = useExperienceSectionState();
    // Stores
    const {isTranslationActivated} = storeToRefs(useTranslationStore());
    const {translateAll, replaceTranslationContent} = useTranslationStore();

    onMounted(() => {
        eventBus.on('translation:request', translateExperiences);
        eventBus.on('translation:restore', restoreExperiences);
    });

    onUnmounted(() => {
        eventBus.off('translation:request', translateExperiences);
        eventBus.off('translation:restore', restoreExperiences);
    });

    async function translateExperiences() {
        const experienceTitleRequests = experiencesSectionState.value.map((exp) => {
            return {
                section: translationSection,
                field: translationTitleField,
                index: exp.index,
                originalContent: exp.title,
            };
        });
        const experienceDescriptionRequests = experiencesSectionState.value.map((exp) => {
            return {
                section: translationSection,
                field: translationDescriptionField,
                index: exp.index,
                originalContent: exp.description,
            };
        });

        await Promise.all([translateAll(experienceTitleRequests), translateAll(experienceDescriptionRequests)]);

        replaceTranslationContent(translationSection, translationTitleField, TranslationDirection.TRANSLATE, switchTranslation);
        replaceTranslationContent(translationSection, translationDescriptionField, TranslationDirection.TRANSLATE, switchTranslation);
    }
    function restoreExperiences() {
        replaceTranslationContent(translationSection, translationTitleField, TranslationDirection.RESTORE, switchTranslation);
        replaceTranslationContent(translationSection, translationDescriptionField, TranslationDirection.RESTORE, switchTranslation);
    }
    function switchTranslation(content: string, index: number, field: string) {
        experiencesSectionState.value[index][field] = content;
    }
</script>
